import { render, staticRenderFns } from "./AddressDetail.vue?vue&type=template&id=602a3ca3&scoped=true"
import script from "./AddressDetail.vue.js?vue&type=script&lang=js&external"
export * from "./AddressDetail.vue.js?vue&type=script&lang=js&external"
import style0 from "./AddressDetail.vue?vue&type=style&index=0&id=602a3ca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602a3ca3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VImg,VTab,VTabItem,VTabs,VTabsItems})
